var y = Object.defineProperty;
var k = (e, n, a) => n in e ? y(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a;
var t = (e, n, a) => k(e, typeof n != "symbol" ? n + "" : n, a);
function St() {
  var e;
  try {
    return typeof ((e = window == null ? void 0 : window.mixpanel) == null ? void 0 : e.get_distinct_id) == "function" ? window.mixpanel.get_distinct_id() : void 0;
  } catch (n) {
    console.error(n);
    return;
  }
}
function w() {
  var e, n;
  return typeof window < "u" && ((n = (e = window.location) == null ? void 0 : e.hostname) == null ? void 0 : n.indexOf("hs-app.local.hsenv.io")) >= 0;
}
function b() {
  return typeof window < "u" && !!window.__STORYBOOK_API__;
}
function h(e) {
  var n;
  return w() ? `${e}${((n = window.hsGlobal) == null ? void 0 : n.mixpanelSuffix) ?? ""}` : e;
}
const T = {
  identify: (e) => {
    console.log("@helpscout/analytics identify:", e);
  },
  reset: () => {
    console.log("@helpscout/analytics reset");
  },
  track: (e, n) => {
    console.log("@helpscout/analytics track:", e, n);
  }
}, I = {
  identify: () => {
  },
  reset: () => {
  },
  track: () => {
  }
};
function c() {
  var e;
  return typeof window < "u" && typeof ((e = window.mixpanel) == null ? void 0 : e.track) == "function" ? window.mixpanel : P();
}
function P() {
  return w() || b() ? T : I;
}
const R = 3e3, O = 50, _ = 500, M = 6, D = 1e3, V = "hs-mixpanel-flag-overrides", u = "hs-mixpanel-flag-cache", l = /* @__PURE__ */ new Map();
F();
let r = null;
function S(e) {
  if (typeof window > "u") return null;
  try {
    const n = window.localStorage.getItem(V);
    if (!n) return null;
    const a = JSON.parse(n), o = a == null ? void 0 : a[e];
    return typeof o == "boolean" || typeof o == "string" ? o : null;
  } catch {
    return null;
  }
}
function F() {
  if (!(typeof window > "u"))
    try {
      const e = window.sessionStorage.getItem(u);
      if (!e) return;
      const n = JSON.parse(e);
      for (const [a, o] of Object.entries(n))
        (typeof o == "boolean" || typeof o == "string") && l.set(a, o);
    } catch {
    }
}
function U(e, n) {
  if (!(typeof window > "u"))
    try {
      const a = window.sessionStorage.getItem(u), o = a ? JSON.parse(a) : {};
      o[e] = n, window.sessionStorage.setItem(u, JSON.stringify(o));
    } catch {
    }
}
async function B(e = R) {
  var a, o, i;
  if (typeof window > "u") return !1;
  const n = Date.now();
  for (; typeof ((o = (a = window.mixpanel) == null ? void 0 : a.flags) == null ? void 0 : o.get_variant_value) != "function"; ) {
    const d = Date.now() - n;
    if (typeof ((i = window.mixpanel) == null ? void 0 : i.track) != "function" && d >= _ || d >= e) return !1;
    await new Promise((x) => setTimeout(x, O));
  }
  return !0;
}
function G() {
  return r || (r = B().then((e) => (e || (r = null), e))), r;
}
async function L(e) {
  const a = await c().flags.get_variant_value(e, !1), o = typeof a == "boolean" || typeof a == "string" ? a : !1;
  return l.set(e, o), U(e, o), o;
}
async function A(e, n = 0) {
  var a;
  for (let o = 0; ; o++) {
    if (await G() && typeof ((a = c().flags) == null ? void 0 : a.get_variant_value) == "function")
      try {
        return await L(e);
      } catch (d) {
        return console.error(d), !1;
      }
    if (o >= n) return !1;
    await new Promise((i) => setTimeout(i, D));
  }
}
async function At(e) {
  await Promise.all(
    e.filter((n) => !l.has(n)).map((n) => A(n, M))
  );
}
function gt(e) {
  const n = W(e);
  return n === void 0 ? void 0 : n === !0;
}
function W(e) {
  const n = S(e);
  return n !== null ? n : l.get(e);
}
async function ft(e) {
  const n = S(e);
  return n !== null ? n === !0 : l.has(e) ? l.get(e) === !0 : await A(e) === !0;
}
const N = "user_";
function yt(e) {
  var n, a;
  if (!e) {
    console.error(
      "@helpscout/analytics: Cannot identify user for MixPanel without a user ID"
    );
    return;
  }
  try {
    (a = (n = c()).identify) == null || a.call(
      n,
      h(`${N}${e}`)
    );
  } catch (o) {
    console.error(
      "@helpscout/analytics: Error identifying user for MixPanel",
      o
    );
  }
}
function kt() {
  var e, n;
  try {
    (n = (e = c()).reset) == null || n.call(e);
  } catch (a) {
    console.error(
      "@helpscout/analytics: Error resetting identity for MixPanel",
      a
    );
  }
}
const K = [
  "Clicked Button",
  "Clicked Copy Workflow Button",
  "Clicked Copy Workflow to Mailbox Button",
  "Clicked Link",
  'In App Tour "Next" Button Clicked',
  'In App Tour "Close" Button Clicked',
  "Signed Up"
];
class s {
  /**
   * Constructor for BaseEvent
   * @param properties - Properties for the event
   */
  constructor(n) {
    /** Event properties */
    t(this, "properties");
    this.properties = n;
  }
  /**
   * Get trackable properties. This is the properties that will be sent to the
   * tracking service. The default implementation adds the following properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   * Override this method to add additional properties.
   * @protected
   */
  getTrackableProperties() {
    return {
      ...this.properties ?? {},
      companyId: window.hsGlobal.companyId,
      memberId: K.includes(this.name) ? window.hsGlobal.memberId : void 0,
      userId: window.hsGlobal.memberId
    };
  }
  /**
   * Get the track function. This is the function that will be used to track the
   * event. The default implementation checks if the environment is a storybook
   * environment or a local environment. If it is a storybook environment, it
   * returns the console track function. If it is a local environment, it returns
   * the console track function. Otherwise, it returns the noop track function.
   * Override this method if you want to use a different tracking service or
   * strategy.
   * @protected
   */
  getAnalyticsService() {
    return c();
  }
  /**
   * Track the event. This is the function that will be called to track the event.
   * The default implementation adds the following properties to the trackable
   * properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   *
   * @returns The current instance of the event
   */
  track() {
    try {
      const n = this.getTrackableProperties();
      this.getAnalyticsService().track(this.name, n);
    } catch (n) {
      console.error("@helpscout/analytics track failed", n);
    }
    return this;
  }
}
class Y extends s {
  constructor({
    pageVisited: a,
    state: o
  }) {
    super({
      pageVisited: a ?? (typeof window < "u" ? window.location.pathname : "/"),
      ...o && { state: o }
    });
    t(this, "name", "pageVisited");
  }
}
class p extends s {
}
class $ extends p {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Button");
  }
}
class H extends p {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Link");
  }
}
class j extends p {
  constructor({
    step: a
  }) {
    var o, i;
    super({
      signUpStep: a,
      com_id: ((o = window.hsGlobal) == null ? void 0 : o.companyId) ?? "",
      usr_id: ((i = window.hsGlobal) == null ? void 0 : i.memberId) ?? ""
    });
    t(this, "name", "Signed Up");
  }
}
class J extends s {
  constructor(a) {
    super({
      currentAvailabilityStatus: a == null ? void 0 : a.currentAvailabilityStatus
    });
    t(this, "name", "accountDropdownOpened");
  }
}
class z extends s {
  constructor(a) {
    super({
      itemType: a.itemType,
      itemValue: a.itemValue
    });
    t(this, "name", "accountDropdownItemClicked");
  }
}
class X extends s {
  constructor(a) {
    super({
      currentStatus: a.currentStatus,
      intendedStatus: a.intendedStatus
    });
    t(this, "name", "availabilityToggleClicked");
  }
}
class q extends s {
  constructor(a) {
    super({
      previousStatus: a.previousStatus,
      newStatus: a.newStatus,
      success: a.success,
      errorType: a.errorType
    });
    t(this, "name", "availabilityChanged");
  }
}
class Q extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsEnabled");
  }
}
class Z extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDisabled");
  }
}
class ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDeleted");
  }
}
class ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsAppliedToInbox");
  }
}
class te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsReviewNotificationClicked");
  }
}
class se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserCreated");
  }
}
class ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserModified");
  }
}
class oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicConvoOverride");
  }
}
class ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueEnabled");
  }
}
class de extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueDisabled");
  }
}
class le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedSearch");
  }
}
class ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedReports");
  }
}
class re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedWorkflows");
  }
}
class me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedViews");
  }
}
class ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedColumns");
  }
}
class pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedColumns");
  }
}
class ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentRemovedFromColumns");
  }
}
class Ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedViews");
  }
}
class xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedWorkflows");
  }
}
class Ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSearch");
  }
}
class we extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsArticleCreated");
  }
}
class Se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsAiAnswersPromoClicked");
  }
}
class m extends s {
  constructor(n) {
    if (!n.inboxForwarderContext && typeof window < "u") {
      const o = window.location.pathname.includes("/settings/inbox");
      super({
        ...n,
        inboxForwarderContext: o ? "inbox-settings" : "setup-guide"
      });
    } else
      super(n);
  }
}
class Ae extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderCancelClicked");
  }
}
class ge extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectChannelsClicked");
  }
}
class fe extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectDifferentEmailClicked");
  }
}
class ye extends m {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderFinishLaterClicked");
  }
}
class ke extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidebarToggled");
  }
}
class be extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyListOpened");
  }
}
class he extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileOpened");
  }
}
class Te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileTabOpened");
  }
}
class Ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidepanelOpened");
  }
}
class Pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileEditSaved");
  }
}
class Re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyPropertiesUpsellClicked");
  }
}
class Oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyOverviewTimeframeChanged");
  }
}
class _e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactProfileTabOpened");
  }
}
class Me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementAdded");
  }
}
class De extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementUpdated");
  }
}
class Ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementDeleted");
  }
}
class Fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improveButtonClicked");
  }
}
class Ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementGenerated");
  }
}
class g extends s {
}
class Be extends g {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Next" Button Clicked');
  }
}
class Ge extends g {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Close" Button Clicked');
  }
}
class Le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxBlankSlateClicked");
  }
}
class We extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxConnectBannerClicked");
  }
}
class Ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxWelcomeModalClicked");
  }
}
class Ke extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepViewed");
  }
}
class Ye extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepCtaClicked");
  }
}
class $e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideHelpLinkClicked");
  }
}
class He extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideDismissed");
  }
}
class je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideRestored");
  }
}
class f extends s {
}
class Je extends f {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsIncluded");
  }
}
class ze extends f {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsExcluded");
  }
}
class v extends s {
}
class C extends s {
}
class Xe extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsMenuOpened");
  }
}
class qe extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsAddMenuOpened");
  }
}
class Qe extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReset");
  }
}
class Ze extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReordered");
  }
}
class en extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnAdded");
  }
}
class nn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnRemoved");
  }
}
class tn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnHeaderClicked");
  }
}
class sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewSorted");
  }
}
class an extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalOpened");
  }
}
class on extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClosed");
  }
}
class dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalSelectAllClicked");
  }
}
class ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClearAllClicked");
  }
}
class cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopied");
  }
}
class rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersEnabled");
  }
}
class mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersDisabled");
  }
}
class un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersEnabled");
  }
}
class pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersDisabled");
  }
}
class vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersContactUsClicked");
  }
}
class Cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersManageClicked");
  }
}
class xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionAdded");
  }
}
class En extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionRemoved");
  }
}
class wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inAppBeaconMessageShown");
  }
}
class Sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupStarted");
  }
}
class An extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconContactStepCompleted");
  }
}
class gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconCustomizeStepCompleted");
  }
}
class fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSelfServiceStepCompleted");
  }
}
class yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupCompleted");
  }
}
class kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentCreated");
  }
}
class bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDeleted");
  }
}
class hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentPublished");
  }
}
class Tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentTestSessionStarted");
  }
}
class In extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceAdded");
  }
}
class Pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceRemoved");
  }
}
class Rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceAdded");
  }
}
class On extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceRemoved");
  }
}
class _n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentNameChanged");
  }
}
class Mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentIdentityChanged");
  }
}
class Dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentConnectionActivated");
  }
}
class Vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepViewed");
  }
}
class Fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepCompleted");
  }
}
class Un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCancelled");
  }
}
class Bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceAdded");
  }
}
class Gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceRemoved");
  }
}
class Ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCompleted");
  }
}
class Wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStarted");
  }
}
class Nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupNextClicked");
  }
}
class Kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupBackClicked");
  }
}
class Yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupTryItOutClicked");
  }
}
class $n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupAddKnowledgeClicked");
  }
}
class Hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersSimulationStarted");
  }
}
class jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "globalBannerCtaClicked");
  }
}
class Jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailGenerated");
  }
}
class zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailAdded");
  }
}
class Xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailUpdated");
  }
}
class qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailDeleted");
  }
}
class Qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "experienceKit");
  }
}
class Zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockFooterCtaClicked");
  }
}
class et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockCancellationBridgeLanded");
  }
}
class nt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "showOriginalClicked");
  }
}
class tt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsViewed");
  }
}
class st extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsSaved");
  }
}
class at extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalEnabled");
  }
}
class ot extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalDisabled");
  }
}
class it extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectClicked");
  }
}
class dt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectionSubmitted");
  }
}
class lt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectSetupCancelled");
  }
}
class ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelDisconnectClicked");
  }
}
class rt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaOnboardingViewed");
  }
}
class mt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaCreateStarted");
  }
}
class ut extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyCreated");
  }
}
class pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyToggled");
  }
}
class vt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPoliciesReordered");
  }
}
class Ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaLearnMoreClicked");
  }
}
const E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountDropdownItemClickedEvent: z,
  AccountDropdownOpenedEvent: J,
  AiAgentConnectionActivatedEvent: Dn,
  AiAgentCreatedEvent: kn,
  AiAgentDeletedEvent: bn,
  AiAgentDocSourceAddedEvent: In,
  AiAgentDocSourceRemovedEvent: Pn,
  AiAgentIdentityChangedEvent: Mn,
  AiAgentNameChangedEvent: _n,
  AiAgentPublishedEvent: hn,
  AiAgentSetupAddKnowledgeClickedEvent: $n,
  AiAgentSetupBackClickedEvent: Kn,
  AiAgentSetupCancelledEvent: Un,
  AiAgentSetupCompletedEvent: Ln,
  AiAgentSetupNextClickedEvent: Nn,
  AiAgentSetupSourceAddedEvent: Bn,
  AiAgentSetupSourceRemovedEvent: Gn,
  AiAgentSetupStartedEvent: Wn,
  AiAgentSetupStepCompletedEvent: Fn,
  AiAgentSetupStepViewedEvent: Vn,
  AiAgentSetupTryItOutClickedEvent: Yn,
  AiAgentTestSessionStartedEvent: Tn,
  AiAgentWebsiteSourceAddedEvent: Rn,
  AiAgentWebsiteSourceRemovedEvent: On,
  AiAnswersDisabledEvent: mn,
  AiAnswersEnabledEvent: rn,
  AiAnswersSimulationStartedEvent: Hn,
  AvailabilityChangedEvent: q,
  AvailabilityToggleClickedEvent: X,
  BeaconContactStepCompletedEvent: An,
  BeaconCustomizeStepCompletedEvent: gn,
  BeaconSelfServiceStepCompletedEvent: fn,
  BeaconSetupCompletedEvent: yn,
  BeaconSetupStartedEvent: Sn,
  ChannelConnectClickedEvent: it,
  ChannelConnectSetupCancelledEvent: lt,
  ChannelConnectionSubmittedEvent: dt,
  ChannelDisconnectClickedEvent: ct,
  ClickedButtonEvent: $,
  ClickedLinkEvent: H,
  CompanyListOpenedEvent: be,
  CompanyOverviewTimeframeChangedEvent: Oe,
  CompanyProfileEditSavedEvent: Pe,
  CompanyProfileOpenedEvent: he,
  CompanyProfileTabOpenedEvent: Te,
  CompanyPropertiesUpsellClickedEvent: Re,
  CompanySidebarToggledEvent: ke,
  CompanySidepanelOpenedEvent: Ie,
  ContactProfileTabOpenedEvent: _e,
  CustomerPortalDisabledEvent: ot,
  CustomerPortalEnabledEvent: at,
  CustomerPortalSettingsSavedEvent: st,
  CustomerPortalSettingsViewedEvent: tt,
  DocsAiAnswersPromoClickedEvent: Se,
  DocsArticleCreatedEvent: we,
  ExperienceKitEvent: Qn,
  GlobalBannerCtaClickedEvent: jn,
  GuardrailAddedEvent: zn,
  GuardrailDeletedEvent: qn,
  GuardrailGeneratedEvent: Jn,
  GuardrailUpdatedEvent: Xn,
  ImproveButtonClickedEvent: Fe,
  ImprovementAddedEvent: Me,
  ImprovementDeletedEvent: Ve,
  ImprovementGeneratedEvent: Ue,
  ImprovementUpdatedEvent: De,
  InAppBeaconMessageShownEvent: wn,
  InAppTourCloseButtonClickedEvent: Ge,
  InAppTourNextButtonClickedEvent: Be,
  InboxAiAnswersDisabledEvent: pn,
  InboxAiAnswersEnabledEvent: un,
  InboxBlankSlateClickedEvent: Le,
  InboxConnectBannerClickedEvent: We,
  InboxForwarderCancelClickedEvent: Ae,
  InboxForwarderConnectChannelsClickedEvent: ge,
  InboxForwarderConnectDifferentEmailClickedEvent: fe,
  InboxForwarderFinishLaterClickedEvent: ye,
  InboxWelcomeModalClickedEvent: Ne,
  PageVisitedEvent: Y,
  PrepaidAiAnswersContactUsClickedEvent: vn,
  PrepaidAiAnswersManageClickedEvent: Cn,
  RoadblockCancellationBridgeLandedEvent: et,
  RoadblockFooterCtaClickedEvent: Zn,
  SentimentRemovedFromColumnsEvent: ve,
  SentimentUsedColumnsEvent: pe,
  SentimentUsedSearchEvent: Ee,
  SentimentUsedViewsEvent: Ce,
  SentimentUsedWorkflowsEvent: xe,
  SetupGuideDismissed: He,
  SetupGuideHelpLinkClicked: $e,
  SetupGuideRestored: je,
  SetupGuideStepCtaClicked: Ye,
  SetupGuideStepViewed: Ke,
  ShowOriginalClickedEvent: nt,
  SignedUpEvent: j,
  SlaCreateStartedEvent: mt,
  SlaLearnMoreClickedEvent: Ct,
  SlaOnboardingViewedEvent: rt,
  SlaPoliciesReorderedEvent: vt,
  SlaPolicyCreatedEvent: ut,
  SlaPolicyToggledEvent: pt,
  ThreadReactionAddedEvent: xn,
  ThreadReactionRemovedEvent: En,
  TopicConvoOverrideEvent: oe,
  TopicUsedColumnsEvent: ue,
  TopicUsedReportsEvent: ce,
  TopicUsedSearchEvent: le,
  TopicUsedViewsEvent: me,
  TopicUsedWorkflowsEvent: re,
  TopicUserCreatedEvent: se,
  TopicUserModifiedEvent: ae,
  TopicValueDisabledEvent: de,
  TopicValueEnabledEvent: ie,
  TopicsAppliedToInboxEvent: ne,
  TopicsDeletedEvent: ee,
  TopicsDisabledEvent: Z,
  TopicsEnabledEvent: Q,
  TopicsReviewNotificationClickedEvent: te,
  ViewClosedConversationsExcludedEvent: ze,
  ViewClosedConversationsIncludedEvent: Je,
  ViewColumnAddedEvent: en,
  ViewColumnHeaderClickedEvent: tn,
  ViewColumnRemovedEvent: nn,
  ViewColumnSortedEvent: sn,
  ViewColumnsAddMenuOpenedEvent: qe,
  ViewColumnsCopiedEvent: cn,
  ViewColumnsCopyModalClearAllClickedEvent: ln,
  ViewColumnsCopyModalClosedEvent: on,
  ViewColumnsCopyModalOpenedEvent: an,
  ViewColumnsCopyModalSelectAllClickedEvent: dn,
  ViewColumnsMenuOpenedEvent: Xe,
  ViewColumnsReorderedEvent: Ze,
  ViewColumnsResetEvent: Qe
}, Symbol.toStringTag, { value: "Module" })), xt = (e) => {
  const n = e.replace(/Event$/, "");
  return n.length === 0 ? "" : n.charAt(0).toLowerCase() + n.slice(1);
}, Et = () => {
  const e = {};
  return new Proxy(e, {
    get: (n, a) => {
      const o = Object.keys(E).find(
        (d) => xt(d) === a
      );
      if (!o)
        throw new Error(`No event found for method: ${String(a)}`);
      const i = E[o];
      return (d = {}) => new i(d).track();
    }
  });
}, bt = Et();
export {
  At as ensureMixpanelFlagsReady,
  St as getDistinctId,
  gt as getMixpanelFlagSync,
  W as getMixpanelVariantValueSync,
  yt as identify,
  ft as isMixpanelFlagEnabled,
  kt as resetIdentity,
  bt as track
};
